/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.amenities.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.amenities = {};
proto.witbooking.backoffice.amenities.v1 = require('./amenity_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.amenities.v1.AmenityAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.amenities.v1.AmenityAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest,
 *   !proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse>}
 */
const methodDescriptor_AmenityAPI_GetAmenities = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.amenities.v1.AmenityAPI/GetAmenities',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest,
  proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse,
  /**
   * @param {!proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest,
 *   !proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse>}
 */
const methodInfo_AmenityAPI_GetAmenities = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse,
  /**
   * @param {!proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.amenities.v1.AmenityAPIClient.prototype.getAmenities =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.amenities.v1.AmenityAPI/GetAmenities',
      request,
      metadata || {},
      methodDescriptor_AmenityAPI_GetAmenities,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.amenities.v1.AmenityAPIPromiseClient.prototype.getAmenities =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.amenities.v1.AmenityAPI/GetAmenities',
      request,
      metadata || {},
      methodDescriptor_AmenityAPI_GetAmenities);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest,
 *   !proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse>}
 */
const methodDescriptor_AmenityAPI_GetAmenitiesByProperty = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.amenities.v1.AmenityAPI/GetAmenitiesByProperty',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest,
  proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse,
  /**
   * @param {!proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest,
 *   !proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse>}
 */
const methodInfo_AmenityAPI_GetAmenitiesByProperty = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse,
  /**
   * @param {!proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.amenities.v1.AmenityAPIClient.prototype.getAmenitiesByProperty =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.amenities.v1.AmenityAPI/GetAmenitiesByProperty',
      request,
      metadata || {},
      methodDescriptor_AmenityAPI_GetAmenitiesByProperty,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.amenities.v1.AmenityAPIPromiseClient.prototype.getAmenitiesByProperty =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.amenities.v1.AmenityAPI/GetAmenitiesByProperty',
      request,
      metadata || {},
      methodDescriptor_AmenityAPI_GetAmenitiesByProperty);
};


module.exports = proto.witbooking.backoffice.amenities.v1;

